import { AppState } from 'pages/app/state';
import { connect, Dispatch } from 'react-redux';
import { LogoutAction } from 'pages/login/actions';
import { ProfileMenu, ConnectedProps, ActionProps } from './component';
import { usernameSelector } from 'pages/user-profile/selectors';
import { connectionSelector } from 'components/connection-status/selectors';
import { languageSelector } from 'pages/settings/selectors';
import { permissionsSelector } from 'pages/login/selectors';

function mapStateToProps(state: AppState): ConnectedProps {
  return {
      username: usernameSelector(state),
      permissions: permissionsSelector(state),
      language: languageSelector(state),
      hasEnterpriseLogin: state.settings.tenant.hasEnterpriseLogin,
      isOnline: connectionSelector(state)
  };
}

function mapDispatchToProps(dispatch: Dispatch<LogoutAction>): ActionProps {
  return {
    logout: () => { dispatch(new LogoutAction('logout')); },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileMenu); 


// WEBPACK FOOTER //
// ./src/components/profile-menu/index.ts